// extracted by mini-css-extract-plugin
export var button = "styles-module--button--8c55a";
export var container_btn = "styles-module--container_btn--bc478";
export var discount_img = "styles-module--discount_img--7e415";
export var lawyer_month_logos = "styles-module--lawyer_month_logos--969a6";
export var message = "styles-module--message--a3661";
export var message_break_line = "styles-module--message_break_line--6f525";
export var topbar = "styles-module--topbar--bab7f";
export var topbar_lawyer_month = "styles-module--topbar_lawyer_month--5158b";